module.exports = __webpack_public_path__ + "img/logo-ffws.15f5e7cc.png";